module.exports = __webpack_public_path__ + "static/media/pttep.f42ede9b.jpg";